import {attr, Model} from 'redux-orm';


export class Replay extends Model {
    toString() {
        return `Replay: ${this.title}`;
    }
}

Replay.modelName = 'replay';
Replay.api = {
    listUrl: '/api/search/'
};
Replay.fields = {
    id: attr(),
    title: attr(),
    uploaded_at: attr(),
    map: attr(),
    player_username: attr(),
    frags: attr(),
    exp: attr(),
    creds: attr(),
    dmg: attr(),
    battle_type: attr(),
    assist: attr(),
};



// WEBPACK FOOTER //
// ./src/models.js